import type { Database } from '@/types/database.types';
import DeleteProjectDialog from './DeleteProjectDialog';

type Project = Database['public']['Tables']['projects']['Row'];
type ProjectTeam = Database['public']['Tables']['projects_team']['Row'];
type Member = Database['public']['Tables']['project_members']['Row'];
type ProjectWithTeamAndMembers = Project & {
  projects_team: ProjectTeam;
} & { project_members: Member[] | null };

export default function DangerZone({
  project,
}: {
  project: ProjectWithTeamAndMembers;
}) {
  return (
    <section className="rounded-lg border-2 border-dashed border-destructive/40 p-6 w-200">
      <h2 className="text-lg font-semibold text-destructive">Danger Zone</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        These actions are permanent and cannot be undone.
      </p>

      <div className="mt-6 flex items-center justify-between">
        <DeleteProjectDialog project={project} />
      </div>
    </section>
  );
}
